import { render } from "./AddOrProductBasePricingDelivery.html?vue&type=template&id=482b5460&scoped=true"
import script from "./AddOrProductBasePricingDelivery.js?vue&type=script&lang=js"
export * from "./AddOrProductBasePricingDelivery.js?vue&type=script&lang=js"

import "./AddOrProductBasePricingDelivery.css?vue&type=style&index=0&id=482b5460&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482b5460"]])

export default __exports__